
export const selectState = (state: any): any => state

export const selectPlayer = (state: any) => state.player

export const selectPrograms = (state: any) => state.programs

export const selectNextAssetProgram = (state: any) => {
    const playerState = selectPlayer(state)
    const programs = selectPrograms(state)

    if (!playerState?.programId) return
    const currentProgram = programs[playerState.programId]
    if (!currentProgram) return

    const currentSeason = programs[currentProgram.seasonPlatformId]
    if (!currentSeason || !currentSeason.seriePlatformId) return

    const serie = programs[currentSeason.seriePlatformId]
    if (!serie) return

    const seasons = serie.seasonIds.map((seasonId:any) => programs[seasonId]).filter(Boolean)
    if (!seasons) return

    if (!currentProgram.number && currentProgram.epDate) {
        const currentserie = programs[currentProgram.seriesPlatformId]
        const episodes = currentserie.episodesList
            .map((episode: {episodeId: string | number}) => programs?.[episode.episodeId])
            .filter(Boolean)
            .sort((a, b) => a.number - b.number || new Date(a.epDate)?.getTime() - new Date(b?.epDate)?.getTime())

        const currentProgramIndex = episodes.findIndex(x => x.id === currentProgram.id)
        return episodes[currentProgramIndex + 1]
    }

    const currentProgramIndex = currentSeason.episodeIds.indexOf(currentProgram.id)
    if (currentProgramIndex !== -1) {
        const nextEpisodeIdToWatch = currentSeason.episodeIds[currentProgramIndex + 1]
        return programs[nextEpisodeIdToWatch]
    }
}